"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FieldItemModule = _interopRequireDefault(require("./FieldItem.module.scss"));

var _Text = _interopRequireDefault(require("../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FieldItem = function FieldItem(_ref) {
  var type = _ref.type,
      label = _ref.label,
      className = _ref.className,
      children = _ref.children,
      inline = _ref.inline;
  var classes = (0, _classnames["default"])(_FieldItemModule["default"].field, inline && _FieldItemModule["default"].inline, className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, label && /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    type: type
  }, label)), children);
};

FieldItem.defaultProps = {
  inline: false
};
var _default = FieldItem;
exports["default"] = _default;